export const milestones = [
  {
    year: '2021',
    title: '从一间宿舍开始',
    desc: '最初只是把室友间的深夜闲聊整理成文字发在小圈子里，没想到第一篇就收到了几十条同款经历的回复。',
  },
  {
    year: '2022',
    title: '五个板块成型',
    desc: '读者越来越多，我们按场景把内容分成宿舍夜聊、课堂八卦、社团趣事、食堂奇遇和校园奇闻，分类浏览从此清晰起来。',
  },
  {
    year: '2024',
    title: '开放读者投稿',
    desc: '投稿邮箱上线，第一篇读者来稿来自一位毕业生，写的是食堂窗口阿姨的隐藏菜单，评论区至今还在补充。',
  },
  {
    year: '2026',
    title: '每日热瓜上线',
    desc: '推出工作日邮件速报，只推送真正值得一读的故事，收到大量“终于不用自己翻”的反馈。',
  },
];

export const principles = [
  {
    icon: 'ri-shield-check-line',
    title: '模糊化个人信息',
    desc: '所有姓名、院系、宿舍楼号都会做脱敏处理，不指向可被识别的具体个人。',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: '不指向具体高校',
    desc: '我们讲的是校园里普遍会发生的故事，而不是给某所学校贴标签。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '不传播未经核实的指控',
    desc: '涉及纠纷与负面事件的内容，若无可靠来源，我们一律不发布。',
  },
  {
    icon: 'ri-heart-3-line',
    title: '保留善意与温度',
    desc: '轻松好笑之外，我们也愿意记录那些被人悄悄温柔对待的瞬间。',
  },
];

export const team = [
  {
    name: '小满',
    role: '主编 · 宿舍夜聊板块',
    desc: '负责选题与终审，最擅长把一件小事讲出画面感，坚信深夜是最好的写作时间。',
    tone: 'primary',
  },
  {
    name: '老周',
    role: '编辑 · 课堂与校园板块',
    desc: '前校园记者，负责事实核查与人物脱敏，也是站内最严格的“标题不夸张”执行者。',
    tone: 'accent',
  },
  {
    name: '糖糖',
    role: '编辑 · 食堂与社团板块',
    desc: '自称干饭研究员，负责读者投稿整理，能从一条三百字的留言里找出最动人的那面。',
    tone: 'secondary',
  },
];